import { FC, HTMLAttributes } from 'react';

import classNames from 'classnames';

import Icon from '@telialt/common-icon/src';

type Props = {
    className?: string;
} & HTMLAttributes<HTMLButtonElement>;

const CloseButton: FC<Props> = ({ className, ...props }) => {
    const closeButtonClassNames = classNames('close', className);

    return (
        <button type="button" {...props} aria-label="Uždaryti" className={closeButtonClassNames}>
            <Icon type="close" />
        </button>
    );
};

export default CloseButton;
